import { useEffect, useState } from "react";
import { Modal, Form, Select, InputNumber, message } from "antd";
import { useGetHandoverEmployeesQuery, useAddHandoverRequestMutation } from "../../../services/handover";
import "./styles.scss";

interface AddHandoverRequestModalProps {
  visible:  boolean;
  onCancel: () => void;
}

interface AddHandoverRequestFormValues {
  employeeId: string;
  amount:     number;
}

const AddHandoverRequestModal = ({ visible, onCancel }: AddHandoverRequestModalProps) => {
  const [form] = Form.useForm<AddHandoverRequestFormValues>();

  const [searchTerm, setSearchTerm] = useState('');
  const [debounced,  setDebounced]  = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebounced(searchTerm.trim()), 300);
    return () => clearTimeout(t);
  }, [searchTerm]);

  const { data: employeeData, isFetching: employeesLoading } = useGetHandoverEmployeesQuery({ search: debounced });
  const [addHandoverRequest, { isLoading: submitting }] = useAddHandoverRequestMutation();

  const employeeOptions = (employeeData?.data || []).map((e) => ({
    value: e._id,
    label: e.name || 'Unknown',
  }));

  const handleClose = () => {
    form.resetFields();
    onCancel();
  };

  const handleFinish = async (values: AddHandoverRequestFormValues) => {
    try {
      await addHandoverRequest(values).unwrap();
      // message.success('Handover request added successfully');
      handleClose();
    } catch {
      /* error toast handled globally by badRequestHandler */
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      title="Add Handover Request"
      okText="Add"
      onOk={() => form.submit()}
      confirmLoading={submitting}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish} className="handover-request-form">
        <Form.Item name="employeeId" label="Employee" rules={[{ required: true, message: 'Please select an employee' }]}>
          <Select
            placeholder="Search employee..."
            loading={employeesLoading}
            showSearch
            filterOption={false}
            onSearch={setSearchTerm}
            notFoundContent={employeesLoading ? 'Searching...' : 'No employees found'}
            options={employeeOptions}
          />
        </Form.Item>

        <Form.Item name="amount" label="Amount" rules={[{ required: true, message: 'Please enter amount' }]}>
          <InputNumber style={{ width: '100%' }} min={0} placeholder="Enter amount" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddHandoverRequestModal;
